// Pilot gating for the seller finance dashboard.
//
// REACT_APP_SELLER_FINANCE is the global on/off (build-time). For a controlled
// pilot, REACT_APP_SELLER_FINANCE_ACCOUNTS optionally narrows it to specific
// connected accounts. Rules:
//   - flag !== 'true'            -> off for everyone
//   - flag === 'true', no list   -> on for all sellers (stage / eventual default-on)
//   - flag === 'true', with list -> on only for accounts in the list (pilot)

export const parseAllowlist = raw =>
  String(raw || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

export const isSellerFinanceEnabledFor = (
  stripeAccountId,
  {
    flag = process.env.REACT_APP_SELLER_FINANCE,
    allowlistRaw = process.env.REACT_APP_SELLER_FINANCE_ACCOUNTS,
  } = {}
) => {
  if (flag !== 'true') return false;
  const allow = parseAllowlist(allowlistRaw);
  if (allow.length === 0) return true; // no allowlist → all sellers
  return !!stripeAccountId && allow.includes(stripeAccountId);
};
